import { OrderItem, PayoutFeeSplit, PayoutSplit, TransactionEvent } from '../types/checkout';

export enum CaptureState {
    Captured = 'captured',
    PartiallyCaptured = 'partially captured',
    Authorized = 'authorized',
}

export enum RefundState {
    Pristine = 'pristine',
    PartiallyRefunded = 'partially refunded',
    Refunded = 'refunded',
}

export enum ItemsMode {
    Both = 'both', // single first
    BothDetailedFirst = 'both detailed first',
    Single = 'single',
    Detailed = 'detailed',
}

export interface TransactionItem {
    captureState: CaptureState;
    refundState: RefundState;
    orderItem: OrderItem;
    capturableAmount: number;
    capturableQuantity: number;
    refundableAmount: number;
    refundableQuantity: number;
    capturableSplits: PayoutSplit[];
    refundableSplits: PayoutSplit[];
    events: TransactionEvent[];
}

export interface OperationItem {
    persisted: TransactionItem;
    operation: {
        amount: number;
        quantity: number;
        splits?: PayoutSplit[];
        feeSplit?: PayoutFeeSplit;
    };
}

export interface NewOperationItem extends OperationItem {
    operation: {
        humanAmount?: string;
        amount: number;
        quantity: number;
        splits?: PayoutSplit[];
        feeSplit?: PayoutFeeSplit;
    };
}

export enum UiState {
    Inactive = 'INACTIVE',
    Form = 'FORM',
    InFlight = 'IN_FLIGHT',
    Success = 'SUCCESS',
    Error = 'ERROR',
}

export interface OperationResponseError {
    code: string;
    message: string;
    errors?: any;
}

export enum PaymentProductType {
    Klarna = 'klarna.klarna',
    Billie = 'klarna.billie',
}
